module.exports = __webpack_public_path__ + "static/optimize-img-2-0a2911af29998873179b458c44875a57.jpg";